import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _DownloadCloudIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M10.0209 3.04764C6.31707 2.62105 2.73368 4.52228 1.01031 7.82837C-0.713067 11.1345 -0.219588 15.1608 2.25118 17.9529C2.61719 18.3665 3.24917 18.4051 3.66277 18.0391C4.07636 17.6731 4.11494 17.0411 3.74894 16.6275C1.82723 14.4559 1.44341 11.3243 2.78382 8.75285C4.12422 6.18144 6.9113 4.70271 9.79204 5.03451C12.6728 5.36631 15.0507 7.43993 15.7714 10.2487C15.8849 10.691 16.2835 11.0002 16.7401 11.0002L18.0008 11.0002C19.7457 10.9988 21.2901 12.1287 21.8172 13.792C22.3442 15.4554 21.7322 17.2685 20.3048 18.2722C19.8531 18.5899 19.7444 19.2136 20.0621 19.6654C20.3797 20.1172 21.0035 20.2259 21.4553 19.9082C23.5962 18.4027 24.5143 15.6831 23.7238 13.188C22.9333 10.6932 20.6163 8.99848 17.9993 9.00019L17.4807 9.00019C16.3464 5.77448 13.4628 3.44408 10.0209 3.04764Z"
        fill={iconColor}
      />
      <Path
        d="M12 12.0002C12.5523 12.0002 13 12.4479 13 13.0002V19.586L15.2929 17.2931C15.6834 16.9026 16.3166 16.9026 16.7071 17.2931C17.0976 17.6836 17.0976 18.3168 16.7071 18.7073L12.7071 22.7073C12.3166 23.0978 11.6834 23.0978 11.2929 22.7073L7.29289 18.7073C6.90237 18.3168 6.90237 17.6836 7.29289 17.2931C7.68342 16.9026 8.31658 16.9026 8.70711 17.2931L11 19.586V13.0002C11 12.4479 11.4477 12.0002 12 12.0002Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const DownloadCloudIcon = assignWithoutSideEffects(_DownloadCloudIcon, {
  componentId: 'DownloadCloudIcon',
});

export default DownloadCloudIcon;
